// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../resources/layout-and-structure/Box.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as View from "../primitives/View.res.js";
import * as Hover from "../primitives/Hover.res.js";
import * as Title from "../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../resources/actions/Button.res.js";
import * as Inline from "../resources/layout-and-structure/Inline.res.js";
import * as TableView from "../resources/tables/TableView.res.js";
import * as TextInput from "../primitives/TextInput.res.js";
import * as CountBadge from "../resources/feedback-indicators/CountBadge.res.js";
import * as IconButton from "../resources/actions/IconButton.res.js";
import * as SliderTrack from "../resources/layout-and-structure/SliderTrack.res.js";
import * as ResourceList from "./ResourceList.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TextFieldStyle from "../resources/selection-and-input/TextFieldStyle.res.js";
import * as CanarySeparator from "../resources/layout-and-structure/CanarySeparator.res.js";
import * as ReactDomElement from "../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as CanaryIconButton from "../resources/actions/CanaryIconButton.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OperationDurations from "./OperationDurations.res.js";
import * as ReactUpdateDebounced from "../primitives/ReactUpdateDebounced.res.js";
import * as ResourceListPagination from "./ResourceListPagination.res.js";
let styles = {
  FiltersBarLayout_root: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderBottomColor-kL6WhQ": "borderBottomColor-xmf12dl",
    "borderBottomStyle-kfdmCh": "borderBottomStyle-x1q0q8m5",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-xso031l",
    "transition-kmkexE": "transition-x1oi88d",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-x1qughib",
    "overflow-kVQacm": "overflow-xb3r6kr",
    "padding-kmVPX3": "padding-xxmtint",
    $$css: "wino-gc:src/core/ResourceListPage.res.js:31"
  }
};
function styleProps(opened) {
  return Stylex.props(styles.FiltersBarLayout_root, {
    opacity: opened ? 1 : 0,
    height: opened ? "60px" : "0px"
  });
}
function ResourceListPage$ResourceListFiltersBarLayout(props) {
  let onRequestReset = props.onRequestReset;
  let onRequestToggle = props.onRequestToggle;
  let opened = props.opened;
  let match = styleProps(opened);
  let rootProps = opened ? undefined : {
    inert: "true"
  };
  let newrecord = {
    ...rootProps
  };
  return JsxRuntime.jsxs(View.make, (newrecord.style = match.style, newrecord.className = match.className, newrecord.children = [JsxRuntime.jsx(SliderTrack.make, {
    children: React.Children.map(props.filters, (child, idx) => JsxRuntime.jsx(React.Fragment, {
      children: child
    }, idx.toString())),
    compact: true,
    gap: "small",
    layout: "Adaptative"
  }), JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(CanarySeparator.make, {
      size: "medium",
      spacing: "s"
    }), onRequestReset !== undefined ? JsxRuntime.jsx(Button.make, {
      label: I18n.t("Erase"),
      variant: "subtle",
      size: "small",
      bold: false,
      icon: "reset_v2",
      onPress: () => onRequestReset()
    }) : JsxRuntime.jsx(Button.make, {
      label: I18n.t("Close"),
      variant: "subtle",
      size: "small",
      bold: false,
      icon: "cross",
      onPress: () => onRequestToggle()
    })],
    space: "none",
    stylex: {
      zIndex: 1
    }
  })], newrecord));
}
let styles$1 = {
  SearchBar_inputContainer: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderBottomRightRadius-kYm2EN": "borderBottomRightRadius-x1nhu2vm",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-xso031l",
    "borderLeftWidth-kZ1KPB": "borderLeftWidth-xyj58a3",
    "borderRightWidth-kWqL5O": "borderRightWidth-xs1s249",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderTopRightRadius-ksF3WI": "borderTopRightRadius-x1lzl9kk",
    "borderTopWidth-kEafiO": "borderTopWidth-x178xt8z",
    "transition-kmkexE": "transition-xz1pui1",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    "gap-kOIVth": "gap-x167g77z",
    "height-kZKoxP": "height-x1vqgdyp",
    "marginLeft-koQZXg": "marginLeft-xh9i6ac",
    "overflow-kVQacm": "overflow-xb3r6kr",
    "paddingRight-kpe85a": "paddingRight-xnuq7ks",
    $$css: "wino-gc:src/core/ResourceListPage.res.js:105"
  },
  SearchBar_textInput: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    $$css: "wino-gc:src/core/ResourceListPage.res.js:124"
  },
  SearchBar_button: {
    "backgroundColor-kWkggS": "backgroundColor-x12peec7",
    "cursor-kkrTdU": "cursor-xt0e3qv",
    "transition-kmkexE": "transition-xq2gx43",
    $$css: "wino-gc:src/core/ResourceListPage.res.js:130"
  }
};
function inputContainerStyleProps(active, focused, hovered) {
  let borderColor = hovered ? "#767589" : focused ? "#A2A1B0" : "#D7D7E0";
  return Stylex.props(styles$1.SearchBar_inputContainer, {
    backgroundColor: "white",
    borderColor: borderColor,
    opacity: active ? 1 : 0,
    marginLeft: "-3px",
    width: active ? "160px" : "0px",
    zIndex: 1
  });
}
function textInputStyleProps() {
  return Stylex.props(styles$1.SearchBar_textInput, {
    color: TextFieldStyle.color(false),
    fontSize: TextFieldStyle.fontSizePx
  });
}
let textInputDOMStyle = {
  width: "0",
  flex: "1"
};
let make = React.memo(props => {
  let onChange = props.onChange;
  let __value = props.value;
  let value = __value !== undefined ? __value : "";
  let inputRef = React.useRef(null);
  let match = Hover.use(undefined, undefined, undefined);
  let match$1 = Hover.use(undefined, undefined, undefined);
  let match$2 = React.useState(() => false);
  let setFocused = match$2[1];
  let focused = match$2[0];
  let match$3 = React.useState(() => value);
  let setSearchQuery = match$3[1];
  let searchQuery = match$3[0];
  let debouncedSearchQuery = ReactUpdateDebounced.use(searchQuery, 500);
  let hovered = match[1] || match$1[1];
  ReactUpdateEffect.use1(() => {
    onChange(debouncedSearchQuery);
  }, [debouncedSearchQuery]);
  ReactUpdateEffect.use1(() => {
    setSearchQuery(param => value);
  }, [value]);
  let focusInput = () => {
    let input = inputRef.current;
    if (!(input == null)) {
      return ReactDomElement.focus(input);
    }
  };
  let blurInput = () => {
    let input = inputRef.current;
    if (!(input == null)) {
      return ReactDomElement.blur(input);
    }
  };
  let toggleInput = () => {
    if (focused) {
      return blurInput();
    } else {
      return focusInput();
    }
  };
  let onKeyDown = React.useCallback(event => {
    let key = event.key;
    let inputs = document.querySelectorAll("input");
    let tmp;
    if (inputs == null) {
      tmp = true;
    } else {
      let len = inputs.length;
      if (len !== 1) {
        tmp = len === 0;
      } else {
        let searchInput = inputs[0];
        tmp = inputRef.current === searchInput;
      }
    }
    let allowFocusInput = tmp && (/^[a-zA-Z0-9]$/.test(key) || key === "Backspace") && !event.ctrlKey;
    if (allowFocusInput) {
      return focusInput();
    } else if (key === "Escape" && focused) {
      setSearchQuery(param => "");
      return blurInput();
    } else {
      return;
    }
  }, [focused]);
  React.useEffect(() => {
    let document = globalThis.document;
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown]);
  let active = focused || searchQuery !== "";
  let match$4 = {
    className: "alignItems-x6s0dn4 display-x3nfvp2",
    "data-style-src": "wino-gc:src/core/ResourceListPage.res.js:101"
  };
  let match$5 = inputContainerStyleProps(active, focused, hovered);
  let match$6 = textInputStyleProps();
  return JsxRuntime.jsxs(View.make, {
    children: [JsxRuntime.jsx(View.make, {
      children: JsxRuntime.jsx(Button.make, {
        tone: {
          NAME: "neutral",
          VAL: {
            accent: focused,
            quiet: !active
          }
        },
        active: hovered,
        icon: "search",
        excludeFromTabOrder: true,
        stylex: active ? Primitive_option.some(styles$1.SearchBar_button) : undefined,
        onPress: active ? undefined : toggleInput
      }),
      ref: Primitive_option.some(match[0])
    }), JsxRuntime.jsxs(View.make, {
      children: [JsxRuntime.jsx(View.make, {
        children: JsxRuntime.jsx(TextInput.make, {
          inputRef: Primitive_option.some(inputRef),
          placeholder: props.placeholder,
          style: textInputDOMStyle,
          value: searchQuery,
          onChange: value => setSearchQuery(param => value),
          onFocus: () => setFocused(param => true),
          onBlur: () => setFocused(param => false)
        }),
        className: match$6.className,
        style: match$6.style
      }), JsxRuntime.jsx(IconButton.make, {
        name: "close_medium",
        size: 17,
        color: "#bdbdca",
        hoveredColor: "#797885",
        onPress: param => setSearchQuery(param => "")
      })],
      ref: Primitive_option.some(match$1[0]),
      className: match$5.className,
      style: match$5.style
    })],
    className: match$4.className,
    style: match$4.style
  });
});
function ResourceListPage$ResourceListHeader$HeaderFiltersBarTrigger(props) {
  let tableBodyRef = props.tableBodyRef;
  let onRequestToggle = props.onRequestToggle;
  let activeFiltersCount = props.activeFiltersCount;
  let filtersBarOpened = props.filtersBarOpened;
  let handleToggle = param => {
    let body = tableBodyRef.current;
    if (body == null) {
      return onRequestToggle();
    }
    let scrolled = body.scrollTop;
    body.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    if (!filtersBarOpened || filtersBarOpened && scrolled < 15) {
      return onRequestToggle();
    }
  };
  let active = activeFiltersCount > 0;
  return JsxRuntime.jsx(Button.make, {
    label: I18n.t("Filters"),
    tone: {
      NAME: "neutral",
      VAL: {
        accent: filtersBarOpened,
        quiet: !filtersBarOpened
      }
    },
    bold: false,
    active: active,
    icon: "filter_v2",
    badgeElement: active ? JsxRuntime.jsx(CountBadge.make, {
      children: activeFiltersCount.toString(),
      size: "small"
    }) : null,
    onPress: handleToggle
  });
}
function ResourceListPage$ResourceListHeader(props) {
  let onRequestGoBack = props.onRequestGoBack;
  let mainAction = props.mainAction;
  let activeFiltersCount = props.activeFiltersCount;
  let filters = props.filters;
  let match = React.useState(() => activeFiltersCount > 0);
  let setFiltersBarOpened = match[1];
  let filtersBarOpened = match[0];
  let handleFiltersBar = () => setFiltersBarOpened(opened => !opened);
  let newrecord = {
    ...{
      className: "backgroundColor-x17suf5r boxSizing-x9f619 borderBottomColor-xmf12dl borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l alignItems-x6s0dn4 display-x78zum5 flexDirection-x1q0g3np gap-x1c1vhfx height-xng8ra padding-xxmtint position-x7wzq59 top-x13vifvy zIndex-xzkaem6",
      "data-style-src": "wino-gc:src/core/ResourceListPage.res.js:332"
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs(View.make, (newrecord.children = [JsxRuntime.jsxs(Inline.make, {
      children: [onRequestGoBack !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(CanaryIconButton.make, {
          iconName: "arrow_left",
          iconWidth: 17,
          iconHeight: 17,
          size: "small",
          onPress: onRequestGoBack
        }), JsxRuntime.jsx(CanarySeparator.make, {
          size: "small",
          spacing: "none"
        })]
      }) : null, JsxRuntime.jsx(Title.make, {
        children: props.title,
        level: 2
      })],
      space: "small",
      grow: false
    }), JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsxs(Inline.make, {
        children: [mainAction, mainAction !== null ? JsxRuntime.jsx(CanarySeparator.make, {}) : null, props.shopFilter, filters.length !== 0 ? JsxRuntime.jsx(ResourceListPage$ResourceListHeader$HeaderFiltersBarTrigger, {
          filtersBarOpened: filtersBarOpened,
          activeFiltersCount: activeFiltersCount,
          onRequestToggle: handleFiltersBar,
          tableBodyRef: props.tableBodyRef
        }) : null, props.searchBar, JsxRuntime.jsx(Box.make, {
          spaceRight: "xsmall"
        })],
        space: "small",
        grow: true
      }), props.actions],
      grow: true
    })], newrecord)), JsxRuntime.jsx(ResourceListPage$ResourceListFiltersBarLayout, {
      filters: filters,
      opened: filtersBarOpened,
      onRequestToggle: handleFiltersBar,
      onRequestReset: props.onRequestResetFilters
    })]
  });
}
function ResourceListPage$ResourceListLayout(props) {
  let match = {
    className: "backgroundColor-x17suf5r borderLeftColor-x1qlbgvd borderLeftStyle-x19ypqd9 borderLeftWidth-xe0pwq display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf height-x5yr21d minHeight-x2lwn1j overflow-xb3r6kr zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/core/ResourceListPage.res.js:425"
  };
  return JsxRuntime.jsx(View.make, {
    children: props.children,
    className: match.className,
    style: match.style
  });
}
let make$1 = React.memo(ResourceListPage$ResourceListLayout);
function ResourceListPage(props) {
  let tableLoadingInteraction = props.tableLoadingInteraction;
  let tableLoadingOperations = props.tableLoadingOperations;
  let __tableHeader = props.tableHeader;
  let __searchBar = props.searchBar;
  let __actions = props.actions;
  let __mainAction = props.mainAction;
  let __activeFiltersCount = props.activeFiltersCount;
  let __filters = props.filters;
  let __shopFilter = props.shopFilter;
  let shopFilter = __shopFilter !== undefined ? __shopFilter : null;
  let filters = __filters !== undefined ? __filters : [];
  let activeFiltersCount = __activeFiltersCount !== undefined ? __activeFiltersCount : 0;
  let mainAction = __mainAction !== undefined ? __mainAction : null;
  let actions = __actions !== undefined ? __actions : null;
  let searchBar = __searchBar !== undefined ? __searchBar : null;
  let tableHeader = __tableHeader !== undefined ? __tableHeader : null;
  let tableBodyRef = React.useRef(null);
  let tableLoadingBarEstimatedDuration = Stdlib_Option.map(tableLoadingOperations, operations => OperationDurations.estimate(undefined, undefined, tableLoadingInteraction, operations));
  React.useLayoutEffect(() => {
    if (tableLoadingOperations !== undefined && tableLoadingInteraction !== undefined) {
      tableLoadingOperations.forEach(operation => OperationDurations.setInteraction(undefined, operation, tableLoadingInteraction));
      return () => {
        tableLoadingOperations.forEach(operation => OperationDurations.clearInteraction(undefined, operation));
      };
    }
  }, [tableLoadingOperations, tableLoadingInteraction]);
  return JsxRuntime.jsxs(make$1, {
    children: [JsxRuntime.jsx(ResourceListPage$ResourceListHeader, {
      title: props.title,
      shopFilter: shopFilter,
      filters: filters,
      activeFiltersCount: activeFiltersCount,
      mainAction: mainAction,
      actions: actions,
      searchBar: searchBar,
      tableBodyRef: tableBodyRef,
      onRequestGoBack: props.onRequestGoBack,
      onRequestResetFilters: props.onRequestResetFilters
    }), tableHeader, JsxRuntime.jsx(View.make, {
      children: JsxRuntime.jsx(TableView.make, {
        data: props.tableData,
        columns: props.tableColumns,
        keyExtractor: props.tableKeyExtractor,
        hideCard: true,
        hideReloadingPlaceholder: true,
        compactRows: true,
        placeholderEmptyState: props.tableEmptyState,
        sortDescriptor: props.tableSortDescriptor,
        onSortChange: props.onTableSortChange,
        bodyRef: tableBodyRef,
        loadingBarEstimatedDuration: tableLoadingBarEstimatedDuration
      }),
      style: {
        display: "flex",
        minHeight: "0",
        paddingTop: "10px",
        flex: "1"
      }
    }), JsxRuntime.jsx(ResourceListPagination.make, {
      currentPage: props.paginationCurrentPage,
      totalPages: props.paginationTotalPages,
      totalCount: props.paginationTotalCount,
      loading: props.paginationLoading,
      lastDirection: props.paginationLastDirection,
      itemsPerPage: ResourceList.defaultEdgesPerPage,
      onRequestPaginate: props.onRequestPaginate,
      tableBodyRef: tableBodyRef
    })]
  });
}
let ResourceListSearchBar = {
  make: make
};
let make$2 = ResourceListPage;
export { ResourceListSearchBar, make$2 as make };
/* styles Not a pure module */